import { fileNameFromUrl } from 'common/services/fileurls';

import { TopicCardAvailableAttachment as ServerTopicCardAvailableAttachment } from 'server/models/TopicCardAvailableAttachment';

export { TopicCardAvailableAttachmentData, TopicCardAvailableAttachmentOptions } from 'server/models/TopicCardAvailableAttachment';

export class TopicCardAvailableAttachment extends ServerTopicCardAvailableAttachment {
    FileName() {
        return fileNameFromUrl(this.AttachmentUrl());
    }
}


// WEBPACK FOOTER //
// ./data/models/TopicCardAvailableAttachment.ts